import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export type VerifyAction = 'verify' | 'email_change';

export interface VerifyResult {
  message?: string;
}

export function useVerifyEmail(action: VerifyAction) {
  const api = useApi();
  const path = action === 'email_change' ? '/auth/confirm-email-change' : '/auth/verify-email';
  return useMutation({
    mutationFn: async (token: string): Promise<VerifyResult> => {
      const { data, error, response } = (await api.POST(path as never, {
        body: { token },
      } as never)) as { data?: unknown; error?: unknown; response: Response };
      if (error) {
        const err = new Error('verify_email_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
      return (data ?? {}) as VerifyResult;
    },
  });
}
